"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressReport = void 0;
const rxjs_1 = require("rxjs");
class ProgressReport {
    constructor() {
        this._stepsSource = new rxjs_1.BehaviorSubject(undefined);
        this._steps$ = this._stepsSource.pipe((0, rxjs_1.filter)(s => !!s));
        this._retriesSource = new rxjs_1.BehaviorSubject(undefined);
        this._retries$ = this._retriesSource.pipe((0, rxjs_1.filter)(s => !!s));
    }
    get steps$() {
        return this._steps$;
    }
    get retries$() {
        return this._retries$;
    }
    step(index, total) {
        let progress;
        if (total === 0) {
            progress = {
                index: index,
                total: total,
                progress: NaN
            };
        }
        else {
            progress = {
                index: index,
                total: total,
                progress: (index + 1) / total
            };
        }
        this._stepsSource.next(progress);
    }
    retry(index, count) {
        const retry = {
            index: index,
            count: count
        };
        this._retriesSource.next(retry);
    }
}
exports.ProgressReport = ProgressReport;
//# sourceMappingURL=progress-report.js.map